import { useRef } from "react";
import styles from "./style.module.scss";
import "./style.scss";

import { Image } from "antd";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow, EffectCreative, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Carousel = ({ data }) => {
  const ref = useRef();

  const items = data?.slide.map((item, index) => (
    <SwiperSlide key={index} className={styles.swiperSlide}>
      <div className={styles.imgContainer}>
        <Image src={item.slideimage} alt={item.name} preview={false} className={styles.img} />
      </div>
    </SwiperSlide>
  ));

  // useEffect(() => {
  //   ref.current.swiper.slideTo(mineSelectedCount <= 0 ? 0 : mineSelectedCount - 1);
  // }, [mineSelectedCount]);

  return (
    <div className={`${styles.swiperArea} swiper-area`}>
      <div className={styles.swiperContainer}>
        {data && data.slide?.length > 0 && (
          <Swiper
            ref={ref}
            navigation={false}
            modules={[EffectCoverflow, EffectCreative, Autoplay, Pagination]}
            className="custom-swiper"
            spaceBetween={0}
            slidesPerView={"auto"}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={true}
            loop={true}
            initialSlide={1}
            direction={"horizontal"}
          >
            {items}
          </Swiper>
        )}
      </div>
      {/* <div
        className={`${styles.swiperNavigate} ${styles.swiperPrev}`}
        // onClick={() => handlePrevSwiper(ref)}
      >
        <Image src={arrowLeft} alt="arrowLeft" width={9} />
      </div>
      <div
        className={`${styles.swiperNavigate} ${styles.swiperNext} `}
        onClick={() => handleNextSwiper(ref)}
      >
        <Image src={arrowRight} alt="arrowRight" width={9} />
      </div> */}
    </div>
  );
};

export default Carousel;
